export function buildInitPromiseIterable (store, missing) {
  let promises = []
  const addPageRequests = (action, m) => {                                // Adds paginated request promises to the list of promises to resolve. See line 70
    let reqsNeeded = Math.ceil(m.length / 20) - 1                         // # of additional requests (pages) needed
    console.log(`${action}: adding ${reqsNeeded} additional pages...`)
    for (let i = 2; i < (reqsNeeded + 2); i++) {                          // let i = 2 ---> must start at page 2 (since page 1 is already in the promise array)
      promises.push(store.dispatch(action, { id__in: m, page: i }))
    }
  }
  let a = ''
  for (let m in missing) {                                                // Based on the type of missing data, this will dispatch the appropriate actions
    switch (m) {
      // case 'bank':
      case 'set':
      case 'ledger':
      case 'location':
      case 'period':
      case 'insurance':
      case 'production':
      case 'line':
      case 'budget':
        a = `fetch${m.charAt(0).toUpperCase() + m.slice(1)}sWithQuery`
        break
      case 'state':
      case 'work_state':
        a = 'fetchStatesWithQuery'
        break
      case 'ap':
      case 'aps':
      case 'accountspayable':
        a = 'fetchApsWithQuery'
        break
      case 'ar':
      case 'ars':
      case 'accountsreceivable':
      case 'bill':
        a = 'fetchArsWithQuery'
        break
      case 'bp':
      case 'billpayment':
      case 'bps':
        a = 'fetchBpsWithQuery'
        break
      case 'pp':
      case 'pps':
      case 'prepayment':
        a = 'fetchPpsWithQuery'
        break
      case 'je':
      case 'jes':
      case 'journalentry':
        a = 'fetchJesWithQuery'
        break
      case 'po':
      case 'pos':
      case 'purchaseorder':
        a = 'fetchPosWithQuery'
        break
      case 'pc':
      case 'pcs':
      case 'pettycash':
        a = 'fetchPcsWithQuery'
        break
      case 'account':
      case 'parent':
      case 'account_cash':
      case 'account_clearing':
      case 'default_accounts':
      case 'default_account_cash':
      case 'default_account_clearing':
      case 'default_account_deposits':
      case 'default_account_discount':
      case 'petty_cash_account':
        a = 'fetchAccountsWithQuery'
        break
      case 'address':
      case 'address_physical':
      case 'address_mailing':
        a = 'fetchAddressesWithQuery'
        break
      case 'company':
        a = 'fetchCompaniesWithQuery'
        break
      case 'customer':
        a = 'fetchCustomersWithQuery'
        break
      case 'tax_code':
        a = 'fetchTaxcodesWithQuery'
        break
      case 'series':
        a = 'fetchSeriesWithQuery'
        break
      case 'batch':
        a = 'fetchBatchesWithQuery'
        break
      case 'source_code':
        a = 'fetchSourcecodesWithQuery'
        break
      case 'country':
        a = 'fetchCountriesWithQuery'
        break
      case 'currency':
        a = 'fetchCurrenciesWithQuery'
        break
      case 'free_field_1':
      case 'free_field_2':
      case 'free_field_3':
      case 'free_field_4':
        a = 'fetchFreefieldsWithQuery'
        break
      case 'vendor':
      case 'third_party_vendor':
        a = 'fetchVendorsWithQuery'
        break
      case 'parent_vendor':
        a = 'fetchSingleVendorWithQuery'
        break
      case 'recon':
        a = 'fetchBankRecsWithQuery'
        break
      case 'relieves':
        a = 'fetchPoLinesWithQuery'
        break
      case 'limit_to_bid':
        a = 'fetchArsWithQuery'
        break
      default:
        continue
    }
    promises.push(store.dispatch(a, { id__in: missing[m] }))
    if (missing[m].length > 20) addPageRequests(a, missing[m])            // If more than 20 models missing, you're going to need send subsequent paginated requests to get all the data needed
  }
  return promises
}

export function buildUpdatePromiseIterable (store, modelsToUpdate, data) {
  let promises = []
  if (!store || !modelsToUpdate || !modelsToUpdate.length) return []
  for (let i = 0; i < modelsToUpdate.length; i++) {
    const { id } = modelsToUpdate[i]
    switch (modelsToUpdate[i].transactionType) {
      case 'Accounts Payable':
        promises.push(store.dispatch('updateAp', { id, data }))
        break
      case 'Journal Entry':
        promises.push(store.dispatch('updateJe', { id, data }))
        break
      case 'Purchase Order':
        promises.push(store.dispatch('updatePo', { id, data }))
        break
      case 'Petty Cash':
        promises.push(store.dispatch('updatePc', { id, data }))
        break
      case 'Accounts Receivable':
        promises.push(store.dispatch('updateAr', { id, data }))
        break
      case 'Bill Payments':
        promises.push(store.dispatch('updateBp', { id, data }))
    }
  }
  return promises
}



// WEBPACK FOOTER //
// ./src/utils/helpers/BuildPromiseIterable.js